<script>

    import { toast } from 'bulma-toast'

    import StatisticsService from '../$services/statistics.service'
    import NumeralMethods from '../$methods/numeral.methods'

    import StatsCard from '../$components/stats.card.svelte'
    import Spinner from '../$components/spinner.svelte'

    export let dateStart = null
    export let dateEnd = null

    let loading = false
    let total = null

    $: if (dateStart && dateEnd)
        getShipmentsTotal()

    async function getShipmentsTotal() {
        loading = true
        total = null

        const resp = await StatisticsService.getShipmentsTotal({
            dateStart: dateStart.toISOString(),
            dateEnd: dateEnd.toISOString(),
        })

        loading = false

        if (!resp.success)
            return toast({ message: resp.error.message, type: 'is-danger' })

        total = typeof resp.data === 'number'
            ? resp.data
            : (resp.data?.total ?? resp.data?.shipmentsTotal ?? 0)
    }

</script>

<StatsCard icon="fa-shipping-fast" meta="Envíos" title="Total de envíos" {dateStart} {dateEnd}>
    <div>
        <Spinner {loading} />
        {#if !loading && total !== null}
            <p class="value">{ NumeralMethods.number(total) }</p>
            <p class="location">Envíos en el periodo</p>
        {/if}
    </div>
</StatsCard>
